export class FetchUsers {
    static readonly type = '[User] FetchUsers';
}
